import { ILabelNames } from 'data/dtos/authentication/i-organization-user-dto'

const generateLabelNames = (isSeller: boolean, isAdmin: boolean) => {
  let lable: ILabelNames = {} as ILabelNames

  if (isSeller) {
    lable.singular = 'Cliente'
    lable.plural = 'Clientes'
    lable.titleHeader = 'Clientes'
    lable.createButton = 'Convidar cliente'
  } else {
    lable.singular = 'Fornecedor'
    lable.plural = 'Fornecedores'
    lable.titleHeader = 'Fornecedores'
    lable.createButton = ''
  }

  if (isAdmin) {
    lable.singular = 'Organização'
    lable.plural = 'Organizações'
    lable.titleHeader = 'Organizações'
    lable.createButton = 'Criar Organização'
  }

  return lable
}

export default generateLabelNames
